/* ==========================================================================
   MODULE CADEAU DU PANIER LATERAL - My Qamis Homme
   --------------------------------------------------------------------------
   Fichier : assets/mqh-panier-cadeau.js

   A charger depuis layout/theme.liquid, juste avant </body> :
     {{ 'mqh-panier-cadeau.js' | asset_url | script_tag }}

   Ce code ne doit PAS vivre dans le snippet : quand le panier lateral se
   recharge, son contenu est injecte en innerHTML, et un <script> insere de
   cette facon n'est jamais execute par le navigateur. Les ecouteurs sont
   donc poses une seule fois sur document : ils survivent a tous les
   rechargements du panier.
   ========================================================================== */

(function () {
  if (window.mqhCadeauPret) return;
  window.mqhCadeauPret = true;

  var PLAFOND = 300;

  function racine(el) {
    return el.closest('[data-mqh-cadeau]');
  }

  function argent(centimes) {
    return '\u20AC' + (centimes / 100).toFixed(2).replace('.', ',');
  }

  function tuiles(r) {
    return Array.prototype.slice.call(r.querySelectorAll('[data-mqh-cadeau-tuile]'));
  }

  function selection(r) {
    return tuiles(r).filter(function (t) {
      return t.getAttribute('aria-pressed') === 'true';
    });
  }

  function erreur(r, texte) {
    var p = r.querySelector('[data-mqh-cadeau-erreur]');
    if (!p) return;
    p.textContent = texte || '';
    p.classList.toggle('is-cache', !texte);
  }

  /* Le champ garde toujours une ligne vide d'avance sous le curseur, et ne
     descend jamais sous sa hauteur de depart (2 lignes). */
  function grandir(ta) {
    var styles = window.getComputedStyle(ta);
    var ligne = parseFloat(styles.lineHeight) || 21;
    var plancher = parseFloat(styles.minHeight) || 60;

    ta.style.height = 'auto';

    var souhaitee = ta.scrollHeight + ligne;
    var finale = Math.max(plancher, Math.min(souhaitee, PLAFOND));

    ta.style.height = finale + 'px';
    ta.style.overflowY = souhaitee > PLAFOND ? 'auto' : 'hidden';
  }

  function majCompteur(r, ta) {
    var cpt = r.querySelector('[data-mqh-cadeau-compteur]');
    if (!cpt) return;
    var n = ta.value.length;
    var max = parseInt(r.dataset.max, 10) || 500;
    var seuil = parseInt(r.dataset.seuil, 10) || Math.round(max * 0.8);
    cpt.textContent = n + ' / ' + max;
    cpt.classList.toggle('is-visible', n >= seuil);
  }

  function majTotal(r) {
    var sel = selection(r);
    var total = 0;
    var carteSel = false;

    sel.forEach(function (t) {
      total += parseInt(t.dataset.prix, 10) || 0;
      if (t.dataset.role === 'carte') carteSel = true;
    });

    var btn = r.querySelector('[data-mqh-cadeau-ajouter]');
    if (btn) {
      btn.textContent = sel.length === 0
        ? r.dataset.libelleVide
        : r.dataset.libelleAjout + ' \u2014 ' + argent(total);
    }

    var zone = r.querySelector('[data-mqh-cadeau-message]');
    if (zone) {
      zone.classList.toggle('is-cache', !carteSel);
      if (carteSel) {
        var champ = zone.querySelector('[data-mqh-cadeau-champ]');
        if (champ) grandir(champ);
      }
    }
  }

  function rafraichir(r) {
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'mqh-cadeau' } }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    var section = r.closest('[data-section-id]');
    var id = section ? section.dataset.sectionId : null;

    if (!id) {
      window.location.reload();
      return;
    }

    fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id))
      .then(function (res) {
        if (!res.ok) throw new Error('section');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var neuf = doc.querySelector('[data-section-id="' + id + '"]') || doc.body.firstElementChild;
        if (neuf) {
          section.innerHTML = neuf.innerHTML;
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function ajouter(r) {
    var btn = r.querySelector('[data-mqh-cadeau-ajouter]');
    var sel = selection(r);
    if (!sel.length || !btn) return;

    var ta = r.querySelector('[data-mqh-cadeau-champ]');
    var manuscrit = r.querySelector('[data-mqh-cadeau-manuscrit]');
    var carteSel = sel.some(function (t) {
      return t.dataset.role === 'carte';
    });

    var message = '';
    if (carteSel) {
      if (manuscrit && manuscrit.checked) {
        message = r.dataset.texteManuscrit;
      } else {
        message = ta ? ta.value.trim() : '';
        if (!message) {
          erreur(r, r.dataset.texteMessageVide);
          if (ta) ta.focus();
          return;
        }
      }
    }

    erreur(r, '');

    var items = sel.map(function (t) {
      var ligne = { id: parseInt(t.dataset.variant, 10), quantity: 1 };
      if (t.dataset.role === 'carte' && message) {
        ligne.properties = {};
        ligne.properties[r.dataset.nomPropriete] = message;
      }
      return ligne;
    });

    btn.disabled = true;
    btn.textContent = r.dataset.libelleEnvoi;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('ajout');
        return res.json();
      })
      .then(function () {
        rafraichir(r);
      })
      .catch(function () {
        btn.disabled = false;
        majTotal(r);
        erreur(r, r.dataset.texteErreur);
      });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var toggle = e.target.closest('[data-mqh-cadeau-toggle]');
    if (toggle) {
      var r1 = racine(toggle);
      if (!r1) return;
      var panneau = r1.querySelector('.mqh-cadeau__panneau');
      var ouvert = r1.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      if (panneau) panneau.classList.toggle('is-cache', !ouvert);
      if (ouvert) {
        majTotal(r1);
        setTimeout(function () {
          r1.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 60);
      }
      return;
    }

    var tuile = e.target.closest('[data-mqh-cadeau-tuile]');
    if (tuile && !tuile.disabled) {
      var r2 = racine(tuile);
      if (!r2) return;
      var actif = tuile.getAttribute('aria-pressed') === 'true';
      tuile.setAttribute('aria-pressed', actif ? 'false' : 'true');
      tuile.classList.toggle('is-on', !actif);
      erreur(r2, '');
      majTotal(r2);
      return;
    }

    var ajout = e.target.closest('[data-mqh-cadeau-ajouter]');
    if (ajout) {
      var r3 = racine(ajout);
      if (r3) ajouter(r3);
    }
  });

  document.addEventListener('input', function (e) {
    if (!e.target || !e.target.closest) return;
    var ta = e.target.closest('[data-mqh-cadeau-champ]');
    if (!ta) return;
    var r = racine(ta);
    if (!r) return;

    var avant = ta.style.height;
    grandir(ta);
    majCompteur(r, ta);
    erreur(r, '');

    if (avant !== ta.style.height) {
      ta.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  });

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest) return;
    var champ = e.target.closest('[data-mqh-cadeau-manuscrit]');
    if (!champ) return;
    var r = racine(champ);
    if (!r) return;
    var ta = r.querySelector('[data-mqh-cadeau-champ]');
    if (!ta) return;

    ta.disabled = e.target.checked;
    if (e.target.checked) {
      ta.value = '';
      majCompteur(r, ta);
    }
    grandir(ta);
    erreur(r, '');
  });
})();